import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { RStatus } from "../../../Application/types";
import { type EmbeddedVideoPreview } from "../../types";

interface EmbeddedVideoState {
  hasAccess?: boolean;
  status: RStatus;
  current?: EmbeddedVideoPreview | null;
  errorMessage: string | undefined;
}

const initialState: EmbeddedVideoState = {
  hasAccess: true,
  status: RStatus.Idle,
  current: undefined,
  errorMessage: undefined,
};

const embeddedVideoSlice = createSlice({
  name: "embeddedVideo",
  initialState: initialState,
  reducers: {
    req(state, _: PayloadAction<{ id: number }>) {
      state.status = RStatus.Pending;
      state.hasAccess = true;
    },
    got(state, action: PayloadAction<{ current: EmbeddedVideoState["current"] }>) {
      state.status = RStatus.Got;
      state.current = action.payload.current;
    },
    err(state, action: PayloadAction<{ errorMessage: EmbeddedVideoState["errorMessage"] }>) {
      state.status = RStatus.Error;
      state.errorMessage = action.payload.errorMessage;
    },
    restricted(state) {
      state.hasAccess = false;
      state.status = RStatus.Got;
    },
    reset() {
      return initialState;
    },
  },
});

export const { req, got, err, restricted, reset } = embeddedVideoSlice.actions;

export default embeddedVideoSlice.reducer;
